import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
  IonCard,
  IonList,
  IonBackButton,
  isPlatform,
} from "@ionic/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetProfileDetail } from "../../store/profileDetail/profileDetail.reducer";
import { resetFormProfile } from "../../store/profileForm/profileForm.reducer";
import { ProfilesAddButton } from "./components/ProfilesAddButton";
import { ProfileSearchBar } from "./components/ProfileSearchBar";
import ProfilesList from "./components/ProfilesList";

const ProfilesListPage: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetFormProfile());
    dispatch(resetProfileDetail());
  }, [dispatch]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Perfiles" : ""}
              defaultHref="/app/tic"
              color="light"
            />
          </IonButtons>
          <IonTitle>Perfiles</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Perfiles</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonCard>
          <ProfileSearchBar />
          <IonList>
            <ProfilesList />
          </IonList>
        </IonCard>
        <ProfilesAddButton />
      </IonContent>
    </IonPage>
  );
};
export default ProfilesListPage;
